import MuiTableCell from './MuiTableCell'

const overrides = {
    MuiTableCell,
}

export default overrides
